@for (control of controlsInOrder; track control) {
  <div>
    @if (schema && schema.properties?.[control]?.type === 'object') {
      <ng-container>
        <h2 class="h4 m0">
          {{ schema.properties?.[control]?.title ?? control | titlecase }}
        </h2>
        @if (schema.properties?.[control]?.description) {
          <small>{{schema.properties?.[control]?.description}}</small>
        }
      </ng-container>
    }
    @if (schema && schema.properties?.[control]) {
      <sfo-dynamic-field
        [schema]="schema.properties?.[control]"
        [aFormControl]="aFormControl"
        [renderMode]="'quickSettings'"
        [control]="control"
      ></sfo-dynamic-field>
    }
  </div>
}
